import { HttpClient } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpHelper } from '../helpers/http-helper';
import { IServerSettings } from '../models/index';
import { AuthenticationService } from './authentication.service';
import { SettingsService } from './settings.service';
import { StorageManagerService } from './storage-manager.service';
import { IApiResult } from '../models/api-result';

@Injectable()
export class DeleteFormService {

  httpHelper: HttpHelper;
  settings: IServerSettings;

  constructor(private http: HttpClient, private settingsService: SettingsService, authService: AuthenticationService, storageManagerService: StorageManagerService) {
    // Define an instance of the http helper class that will be used to create httpHeader for api calls
    this.httpHelper = new HttpHelper(http, authService, storageManagerService);
  }

  deleteForm(revisionId: string, apiController: string, modifiedByUser:string, appVariantName: string = '', isDelivery = false): Observable<any> {
    let headers = this.httpHelper.createHttpHeaders(appVariantName);
    headers = headers.set('modifiedByUser', modifiedByUser);
    this.settings = this.settingsService.getSettings();
    const apiUrl = this.settings.ApiGatewayUrl;
    const action = `ssdpds/v1/${apiController}/Deactivate${isDelivery ? 'Delivery' : ''}/${revisionId}`;

    return this.http.post(`${apiUrl}/${action}`, {}, { headers: headers })
      .pipe(map(this.extractData),
        catchError(this.handleErrors));
  }

  private extractData(response: any) {
    if (response.status < 200 || response.status >= 300) {
      throw new Error('Bad response status: ' + response.status);
    }
    const body = response as IApiResult;
    return body;
  }

  // Error handling
  private handleErrors(error: any): Observable<any> {
    const GENERIC_ERROR_MSG = 'It looks like something went wrong. Try reloading the page or contacting support if this issue continues.';
    const bDisplayDetailMsg = error && error.error && error.error.isBusinessErrorMessage ? true : isDevMode() ? true : false;
    error.error = error && error.error && error.error.message && bDisplayDetailMsg ? error.error.message : GENERIC_ERROR_MSG;

    return throwError(error.error);
  }
}
